import React, { FC } from 'react'

import { IconHomeProps } from './IconHome.types'
import * as Styled from './styles/IconHome.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHome: FC<IconHomeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHomeProps['size'],
  isResponsive = false,
}: IconHomeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M33 42.98V32.038a3.08 3.08 0 0 0-3.117-3.023h-3.765A3.08 3.08 0 0 0 23 32.038V42.98'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M28.195 36.108h1.477' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M21.05 6.25S7.275 16.45 5.845 17.795c-2.217 2.087.335 5.23 3.018 5.23h30.41c2.684 0 4.92-3.33 3.02-5.23-1.9-1.9-15.206-11.545-15.206-11.545-2.285-1.82-4.257-1.408-6.037 0Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M38.975 15.082V5.125h-4.928a3.235 3.235 0 0 0-3.224 3.223v.664M8.932 22.98h30v16a4 4 0 0 1-4 4h-22a4 4 0 0 1-4-4v-16Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconHome
